import constate from "constate";
import { useState } from "react";
import { IBankAccount } from "~/services/api/bankAccount";
import { IPartner, IPartnerUnion } from "~/services/api/partner";
const [PartnerProvider, usePartner] = constate(() => {
  const [partners, setPartners] = useState<IPartner[]>([]);
  const [partner, setPartner] = useState<IPartnerUnion | null | undefined>();
  const [bankAccounts, setBankAccounts] = useState<IBankAccount[]>([]);
  const [addBankAccounts, setAddBankAccounts] = useState<boolean>(false);
  const [bankAccountData, setBankAccountData] = useState<IBankAccount | null>(
    null
  );

  const [tab, setTab] = useState(0);

  const [addDocument, setAddDocument] = useState<boolean>(false);

  return {
    addDocument,
    setAddDocument,
    partners,
    setPartners,
    bankAccounts,
    setBankAccounts,
    tab,
    setTab,
    partner,
    setPartner,
    addBankAccounts,
    setAddBankAccounts,
    bankAccountData,
    setBankAccountData,
  
  };
});

export { PartnerProvider };
export default usePartner;
